function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconBecomeMember = function IconBecomeMember(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    width: "100",
    height: "92",
    viewBox: "0 0 100 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: "3"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4716_16004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 33.4545C46.1294 33.4545 53.125 26.4335 53.125 17.7726C53.125 9.11181 46.1294 2.09082 37.5 2.09082C28.8706 2.09082 21.875 9.11181 21.875 17.7726C21.875 26.4335 28.8706 33.4545 37.5 33.4545Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0007 83.6362C84.2054 83.6362 91.6673 76.1471 91.6673 66.9089C91.6673 57.6707 84.2054 50.1816 75.0007 50.1816C65.7959 50.1816 58.334 57.6707 58.334 66.9089C58.334 76.1471 65.7959 83.6362 75.0007 83.6362Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 56.4541V77.3632",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.584 66.9092H85.4173",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4716_16004",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "37",
    width: "100",
    height: "55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 37.4688H0V91.9997H75V89.9088C62.3542 89.9088 52.0833 79.6006 52.0833 66.9088C52.0833 54.2169 62.3542 43.9088 75 43.9088C87.6458 43.9088 97.9167 54.2169 97.9167 66.9088H100V37.4688Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4716_16004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6673 60.6356C66.6673 50.2437 58.2715 41.8174 47.9173 41.8174H27.084C16.7298 41.8174 8.33398 50.2437 8.33398 60.6356V68.9992",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4716_16004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100",
    height: "92",
    fill: "white"
  }))));
};